export const TOKEN = 'authorization'
export const MENU = 'menu'
export const ENTITY = 'entity'

// 路由path相关变量
export const ROUTES = {
 layout: 'layout',
 index: '/index',
 entity: '/entity',
 user: '/user',
 sys: '/system',
 remote: '/remote',
}
